import { Controller } from "@hotwired/stimulus"

// Toggles a password-style input between masked/revealed and keeps a paired
// <code> snippet in sync (swapping its masked display for the real value).
// Used on the settings Token Authentication card.
export default class extends Controller {
  static targets = ["input", "snippet", "toggleBtn"]

  connect() {
    this._revealed = false
  }

  toggle() {
    this._revealed = !this._revealed
    if (this.hasInputTarget) {
      this.inputTarget.type = this._revealed ? "text" : "password"
    }
    if (this.hasSnippetTarget) {
      const el = this.snippetTarget
      el.textContent = this._revealed
        ? (el.dataset.fullValue || el.textContent)
        : (el.dataset.maskedValue || el.textContent)
    }
    if (this.hasToggleBtnTarget) {
      this.toggleBtnTarget.textContent = this._revealed ? "Hide" : "Show"
    }
  }
}
